var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b3b7c1",
    d: "M10.922 8.109 7.5 4.64 9 2.999h6l1.828 2.016h3.188q.797 0 1.383.586t.586 1.383v12.188l-5.109-5.109q.141-.516.141-1.078 0-1.359-.68-2.508t-1.828-1.805-2.508-.656q-.516 0-1.078.094zm9.562 15.188L18.187 21H3.984q-.797 0-1.383-.586t-.586-1.43v-12q0-.422.188-.82t.469-.633L.703 3.515l1.406-1.406L21.89 21.89zm-6-6-1.5-1.5q-.234.094-.469.141t-.516.047q-.844 0-1.523-.398t-1.078-1.078T9 12.986q0-.234.047-.492t.141-.492l-1.5-1.5q-.703 1.172-.703 2.484 0 1.406.68 2.531t1.828 1.805 2.508.68q.703 0 1.313-.188t1.172-.516z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.ae663dafdc33c205dd1d6e93c148bd5c.svg";
export { ForwardRef as ReactComponent };